"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };

exports.default = configureStore;

var _redux = require("redux");

var _rootReducer = require("../reducers/rootReducer");

var _rootReducer2 = _interopRequireDefault(_rootReducer);

var _reduxThunk = require("redux-thunk");

var _reduxThunk2 = _interopRequireDefault(_reduxThunk);

var _reduxApiMiddleware = require("redux-api-middleware");

var _reactRouterRedux = require("react-router-redux");

var _reduxPersist = require("redux-persist");

var _constants = require("redux-persist/constants");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function configureStore(reactRouterSingletonHistory) {
    var initialState = arguments.length <= 1 || arguments[1] === undefined ? undefined : arguments[1];

    // general middlewares
    var middlewares = [(0, _reactRouterRedux.routerMiddleware)(reactRouterSingletonHistory), _reduxThunk2.default, _reduxApiMiddleware.apiMiddleware // RSAA compliant api calling middleware
    ];
    // Middlewares for dev-only usage...
    if (__DEVELOPMENT__) {
        // proper console logging of dispatched actions
        middlewares.push(require("redux-logger")());
        // make sure all dispatched actions are compliant to the flux-standard-action spec
        // see https://github.com/acdlite/flux-standard-action for more information
        // this middleware accepts a param with ignored action types (only use for 3rd party libs) which should not be validated (e.g. REHYDRATE is not compliant as it uses a extra key property)
        middlewares.push(require("redux-validate-fsa")([_constants.REHYDRATE]));
    }
    // compose our single-truth store...
    var store = (0, _redux.compose)(_redux.applyMiddleware.apply(undefined, middlewares), (typeof window === "undefined" ? "undefined" : _typeof(window)) === "object" && typeof window.devToolsExtension !== "undefined" ? window.devToolsExtension() : function (f) {
        return f;
    })(_redux.createStore)(_rootReducer2.default, initialState);
    // enable localStorage persistance layer... (attention, do not use autorehydrate as it blocks dispatch calls!
    // instead the reducers that need rehydration must implement the REHYDRATE handler (and if needed the COMPLETE rehydration handler))
    (0, _reduxPersist.persistStore)(store, {
        whitelist: ["auth", "app"],
        keyPrefix: "reduxPersistApp:" // default: "reduxPersist:", use a custom prefix so the rehydration from cms does not clash with app
    });
    // Enable Webpack hot module replacement for reducers
    if (__DEVELOPMENT__ && module.hot) {
        module.hot.accept("../reducers/rootReducer", function () {
            var nextReducer = require("../reducers/rootReducer");
            store.replaceReducer(nextReducer);
        });
    }
    return store;
}
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/store/configureStore.ts
 ** module id = 1301
 ** module chunks = 0
 **/